const discountTypes = [
  { title: 'Percentage', value: 'Percent' },
  { title: 'Fixed Amount', value: 'Value' }
];
const useTypes = [
  { title: 'Single Use', value: 'SingleUse' },
  { title: 'Multi Use', value: 'MultiUse' },
  { title: 'Once Per Customer', value: 'OncePerCustomer' }
];
export const getDiscountType = (codeType?: string): { title: string, value: string; } | undefined => {

  if (!codeType) {
    return;
  }
  return discountTypes.find(type => codeType.includes(type.value));
};
export const getUseType = (codeType: string): { title: string, value: string; } | undefined => {

  if (!codeType) {
    return;
  }
  return useTypes.find(type => codeType.includes(type.value));
};